import PogPeriodicity from './PogPeriodicity';

export default PogPeriodicity;
